module.exports = __webpack_public_path__ + "static/media/435_Front.426f4984.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/435_Front.jpg
// module id = 560
// module chunks = 0